<template>
  <div class="venue-info">
    <template v-if="type=='promoter'">
      <TextField  
        :id="'company_name'"
        v-bind="textFieldConfig"
        :value="contact.company_name"
        required
        :placeholder="$t('company_name')"
        @valuechanged="onTextfieldValueChangd"
        @validated="onValidation"
      ></TextField>
    </template>
    <template v-else>
      <TextField  
        :id="'first_name'"
        v-bind="textFieldConfig"
        :value="contact.first_name"
        required
        :placeholder="$t('first_name')"
        @valuechanged="onTextfieldValueChangd"
        @validated="onValidation"
      ></TextField>
    </template>
    <TextField  
      :id="'address1'"
      v-bind="textFieldConfig"
      :value="contact.address1"
      required
      :placeholder="$t('address1')"
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField>
    <TextField  
      :id="'address2'"
      v-bind="textFieldConfig"
      :value="contact.address2"
      required
      :placeholder="$t('address2')"
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField>
    <TextField  
      :id="'city'"
      v-bind="textFieldConfig"
      :value="contact.city"
      required
      :placeholder="$t('city')"
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField>
    <TextField  
      :id="'postalcode'"
      v-bind="textFieldConfig"
      :value="contact.postalcode"
      required
      :placeholder="$t('postalcode')"
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField>
    <Dropdown
      class="dt-dropdown"
      :options="countriesTV"
      :selected="countriesTV.find(e => e.value == contact.country)"
      :disabled="allDisabled"
      box
      :placeholder="$t('country')"
      v-on:selectedChange="e => onDropdownChange('country', e)"
      :listHeight="95"
    ></Dropdown>
    <TextField  
      :id="'phone1'"
      v-bind="textFieldConfig"
      :value="contact.phone1"
      :placeholder="$t('phone1')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField  
      :id="'phone2'"
      v-bind="textFieldConfig"
      :value="contact.phone2"
      :placeholder="$t('phone2')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField  
      :id="'email1'"
      v-bind="textFieldConfig"
      :value="contact.email1"
      :placeholder="$t('email')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <template v-if="type=='promoter'">
      <TextField 
        :id="'vat_no'"
        v-bind="textFieldConfig"
        :value="contact.vat_no"
        :placeholder="$t('eu_tax_ident')"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField>
      <TextField  
        :id="'tax_no'"
        v-bind="textFieldConfig"
        :value="contact.tax_no"
        :placeholder="$t('tax_id')"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField>
    </template>
    <template v-else>
      <TextField 
        :id="'contact_fax1'"
        v-bind="textFieldConfig"
        :value="contact.contact_fax1"
        :placeholder="$t('fax')"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField>
      <TextField  
        :id="'contact_chat3'"
        v-bind="textFieldConfig"
        :value="contact.contact_chat3"
        :placeholder="$t('skype_im')"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField>
    </template>
  </div>
</template>

<script>
import Dropdown from '@plugins/dropdown/dropdown';
import TextField from '@plugins/text-field/text-field';
import { createContact } from '../../models/contact.model';

export default {
  components: {
    Dropdown,
    TextField
  },
  props: {
    contact: {
      required: true,
      type: Object,
      default: () => createContact({})
    },
    countries: {
      required: true,
      type: Array,
      default: () => []
    },
    allDisabled: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => 'promoter'
    }
  },
  data: function() {
    return {      
      validationResult: {},
    }
  },
  computed: {
    countriesTV: function() {
      return this.countries.map(e => ({
        text: e,
        value: e
      }))
    },
    textFieldConfig: function() {
      return {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        disabled: this.isControlDisabled,
        showValidationIcons: true,
        statusInside: true,
      }
    },
    isControlDisabled: function() {
      if (this.allDisabled) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    onTextfieldValueChangd: function(name, value) {
      this.$emit('changed', {name, value});
    },
    onValidation: function(id, validationResult) {
      // console.warn(id, validationResult);
      this.$set(this.validationResult, id, validationResult);
    },
    onDropdownChange: function(name, value) {
      console.log(name, value);
      this.$emit('changed', {name, value});
    }
  }
}
</script>


<style lang="scss" scoped>
  .dropdown.box {
    margin: 5px;
  }
</style>
